import Immutable from 'immutable';


const ApplicationRecord = Immutable.Record({
    driver: {
        selected: null,
        highlighted: null,
        filter: {
            free: true,
            busy: true,
            returning: true,
        }
    },
    order: {
        selected: null,
        highlighted: null,
    },
    scheduled: {
        selected: null,
        highlighted: [],
        action: {
            confirmation: [],
            pending: [],
        },
        status: {
            dispatched: []
        }
    }
});


export default ApplicationRecord;


// WEBPACK FOOTER //
// ./src/data/record/ApplicationRecord.js